module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_date":"Filter by date","all_contents":"All content"},"fr":{"filter_date":"Filtrer par date","all_contents":"Tous les contenus"}}')
  delete Component.options._Ctor
}
